import FormSectionTitle from '../../../../elements/FormSectionTitle'
import CustomTable from '../../../../elements/Table/CustomTable'
import { get, round } from 'lodash'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

function PackingList(props) {
  const { list, setClicked, fetching, fetch } = props
  const PackageColumns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 120,
      Cell: ({ value, original }) => (
        <a onClick={() => setClicked({ original, type: 'package' })}>{value}</a>
      ),
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Unit', accessor: 'unit', width: 120 },
    { Header: 'From', accessor: 'from.address.label' },
    { Header: 'From', accessor: 'from.location', hideable: true, hideDefault: true },
    { Header: 'To', accessor: 'to.address.label' },
    { Header: 'To', accessor: 'to.location', hideable: true, hideDefault: true },
  ]

  const CargoColumns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => (
        <Link
          target={'_blank'}
          to={{
            pathname: `/purchasing/cargo/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Title',
      accessor: 'title',
    },
    {
      Header: 'Height',
      accessor: 'shipping.dimensions.height',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'shipping.dimensions.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Length',
      accessor: 'shipping.dimensions.length',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'shipping.dimensions.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Length',
      accessor: 'shipping.dimensions.width',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'shipping.dimensions.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Weight',
      accessor: 'shipping.weights.net',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'shipping.weights.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Volume',
      accessor: 'shipping.volume.volume',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'shipping.volume.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
    },
  ]

  return (
    <Fragment>
      <div>
        <CustomTable
          data={list}
          columns={CargoColumns}
          fetching={fetching}
          fetch={fetch}
          defaultPageSize={10}
          SubComponent={row => {
            return (
              <div style={{ padding: '20px' }}>
                <FormSectionTitle title={'Package LINES'} padding={'0px'} />
                <em>You can Edit or view Packages inside this Cargo</em>
                <br />
                <br />
                <CustomTable
                  data={row.original.packages}
                  columns={PackageColumns}
                  fetching={fetching}
                  fetch={fetch}
                  defaultSorted={[
                    {
                      id: 'no',
                      desc: false,
                    },
                  ]}
                  style={{ marginTop: 10 }}
                />
              </div>
            )
          }}
        />
        <br />
      </div>
    </Fragment>
  )
}

export default PackingList
